import AdminGlobalHeader from "./AdminGlobalHeader";

export default AdminGlobalHeader;
